export default "__VITE_ASSET__BRzBG_wH__"